(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ntw-review-slider"] && !Shopify.designMode) return;
  try {
    
  /* External Swiper assets (load once per theme) */
  if (!window._ntwReviewSliderSwiperLoaded) {
    document.head.insertAdjacentHTML(
      'beforeend',
      '<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css">'
    );
    document.head.insertAdjacentHTML(
      'beforeend',
      '<script src="https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js"><\/script>'
    );
    window._ntwReviewSliderSwiperLoaded = true;
  }

  const ntwInitSwiper = () => {
    const sliders = document.querySelectorAll('.ntw-review-slider-swiper');
    sliders.forEach((el) => {
      if (el.dataset.ntwSwiperInit) return;

      const parentSection = el.closest('.ntw-review-slider-section');
      const nextBtn = parentSection.querySelector('.ntw-review-slider-next');
      const prevBtn = parentSection.querySelector('.ntw-review-slider-prev');

      new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 10, /* decreased from 20 */
        loop: true,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
        breakpoints: {
          500: { slidesPerView: 2 },
          950: { slidesPerView: 3 }
        }
      });

      el.dataset.ntwSwiperInit = 'true';
    });
  };

  const tryInitialize = () => {
    if (window.Swiper && document.readyState !== 'loading') {
      ntwInitSwiper();
    }
  };

  document.addEventListener('DOMContentLoaded', tryInitialize);

  document.addEventListener('swiper:loaded', () => {
    if (document.readyState !== 'loading') {
      ntwInitSwiper();
    } else {
      document.addEventListener('DOMContentLoaded', ntwInitSwiper, { once: true });
    }
  }, { once: true });

  const checkSwiper = setInterval(() => {
    if (window.Swiper) {
      clearInterval(checkSwiper);
      document.dispatchEvent(new CustomEvent('swiper:loaded'));
    }
  }, 50);

  } catch(e) { console.error(e); }
})();
})();
